<template>
  <div>
    <!-- <b-col cols="4"> -->
    <b-row>
      <b-col cols="3">
        <b-card header="Third Party Details">
          <b-card-body class="scrollFlow" style="height: 350px; overflow: hidden auto;">
            <b-row>
              <b-col cols="6">
                <h6>Third Party Name:</h6>
              </b-col>
              <b-col cols="6">
                <h6>{{ thirdPartyData ? thirdPartyData.comp_name_eng ? thirdPartyData.comp_name_eng : "....." : "....." }}</h6>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="6">
                <h6>Uploaded Date:</h6>
              </b-col>
              <b-col cols="6">
                <h6>{{ thirdPartyData ? thirdPartyData.created_date ? thirdPartyData.created_date : "....." : "....." }}</h6>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="6">
                <h6>Address:</h6>
              </b-col>
              <b-col cols="6">
                <h6>{{ thirdPartyData ? thirdPartyData.contact_address ? thirdPartyData.contact_address : "....." : "....." }}</h6>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="6">
                <h6>Country:</h6>
              </b-col>
              <b-col cols="6">
                <h6>{{ thirdPartyData ? thirdPartyData.country ? thirdPartyData.country : "....." : "....." }}</h6>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="6">
                <h6>URL:</h6>
              </b-col>
              <b-col cols="6">
                <h6>
                  <a
                    href="#"
                  >{{ thirdPartyData ? thirdPartyData.website ? thirdPartyData.website : "....." : "....." }}</a>
                </h6>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="6">
                <h6>Primary Contact Name:</h6>
              </b-col>
              <b-col cols="6">
                <h6>{{ thirdPartyData ? thirdPartyData.contact_name ? thirdPartyData.contact_name : "....." : "....." }}</h6>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="6">
                <h6>Primary Contact Title:</h6>
              </b-col>
              <b-col cols="6">
                <h6>{{ thirdPartyData ? thirdPartyData.contact_title ? thirdPartyData.contact_title : "....." : "....." }}</h6>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="6">
                <h6>Primary Contact Phone:</h6>
              </b-col>
              <b-col cols="6">
                <h6>{{ thirdPartyData ? thirdPartyData.contact_phone ? thirdPartyData.contact_phone : "....." : "....." }}</h6>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="6">
                <h6>Primary Contact Email:</h6>
              </b-col>
              <b-col cols="6">
                <h6>
                  <a
                    href="#"
                  >{{ thirdPartyData ? thirdPartyData.contact_email ? thirdPartyData.contact_email : "....." : "....." }}</a>
                </h6>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="6">
                <h6>Created By:</h6>
              </b-col>
              <b-col cols="6">
                <h6>{{ thirdPartyData ? thirdPartyData.third_party_created_by ? thirdPartyData.third_party_created_by : "....." : "....." }}</h6>
              </b-col>
            </b-row>
            <br />
          </b-card-body>
        </b-card>
      </b-col>
      <b-col cols="3">
        <b-card header="Associates">
          <b-card-body class="scrollFlow" style="height: 350px; overflow: hidden auto;">
            <b-row>
              <b-col cols="6">
                <h6>
                  <b>Associates Names</b>
                </h6>
              </b-col>
              <b-col cols="6">
                <h6>
                  <b>Role</b>
                </h6>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="6">
                <h6>Jane Doe</h6>
              </b-col>
              <b-col cols="6">
                <h6>Chief Executive Officer</h6>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="6">
                <h6>John Smith</h6>
              </b-col>
              <b-col cols="6">
                <h6>Company Secretary</h6>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col cols="3">
        <b-card header="Third Party Custom Attributes">
          <b-card-body class="scrollFlow" style="height: 350px; overflow: hidden auto;">
            <b-row>
              <b-col cols="6">
                <h6>Third Party Type:</h6>
              </b-col>
              <b-col cols="6">
                <h6>{{ thirdPartyData ? thirdPartyData.tpi_type ? thirdPartyData.tpi_type : "....." : "....." }}</h6>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="6">
                <h6>Contract Valid From:</h6>
              </b-col>
              <b-col cols="6">
                <h6>{{ thirdPartyData ? thirdPartyData.contract_valid_from ? thirdPartyData.contract_valid_from : "....." : "....." }}</h6>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="6">
                <h6>Contract Expires:</h6>
              </b-col>
              <b-col cols="6">
                <h6>{{ thirdPartyData ? thirdPartyData.contract_expires ? thirdPartyData.contract_expires : "....." : "....." }}</h6>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="6">
                <h6>Contract Value:</h6>
              </b-col>
              <b-col cols="6">
                <h6>Contract Value</h6>
                <!-- <h6>{{ thirdPartyData ? thirdPartyData.comp_name_eng : "....." }}</h6> -->
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="6">
                <h6>Contract Currency:</h6>
              </b-col>
              <b-col cols="6">
                <h6>Contract Currency</h6>
                <!-- <h6>{{ thirdPartyData ? thirdPartyData.comp_name_eng : "....." }}</h6> -->
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="6">
                <h6>Risk Comments:</h6>
              </b-col>
              <b-col cols="6">
                <h6>Risk Comments</h6>
                <!-- <h6>{{ thirdPartyData ? thirdPartyData.comp_name_eng : "....." }}</h6> -->
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col cols="3">
        <b-card header="Self Reported Data">
          <b-card-body class="scrollFlow" style="height: 350px; overflow: hidden auto;">
            <b-row>
              <b-col cols="6">
                <h6>Written Contracts</h6>
              </b-col>
              <b-col cols="6">
                <h6>Written Contracts</h6>
                <!-- <h6>{{ thirdPartyData ? thirdPartyData.comp_name_eng : "....." }}</h6> -->
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="6">
                <h6>Code of Conduct</h6>
              </b-col>
              <b-col cols="6">
                <h6>{{ thirdPartyData ? thirdPartyData.code_of_conduct ? thirdPartyData.code_of_conduct : "....." : "....." }}</h6>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="6">
                <h6>Modern Slavery Commitment</h6>
              </b-col>
              <b-col cols="6">
                <h6>Modern Slavery Commitment</h6>
                <!-- <h6>{{ thirdPartyData ? thirdPartyData.comp_name_eng : "....." }}</h6> -->
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "ThirdPartyDetailsAssocTabComponent",
  data() {
    return {};
  },
  props: {
    thirdPartyData: Object
  }
};
</script>
<style scoped>
.scrollFlow::-webkit-scrollbar {
  display: none;
}
</style>